import { Footer, Container, Link } from "@postenbring/hedwig-react";

export const PostenFooter = ({ footerData }) => {
    const switchLanguageButton = footerData?.switchLanguageLink ? (
        <Footer.ButtonLink href={footerData.switchLanguageLink.url}>
            {footerData.switchLanguageLink.title}
        </Footer.ButtonLink>
    ) : null;

    const buttons = footerData?.buttons?.map((button, index) => (
        <Footer.ButtonLink key={button.url ?? index} href={button.url}>
            {button.title}
        </Footer.ButtonLink>
    ));

    const mainSections = footerData?.mainSections?.map((section, index) => (
        <Footer.LinkSection heading={section.heading} key={section.heading ?? index}>
            {section.items.map((item, index) => {
                return (
                    <li key={item.url ?? index}>
                        <a href={item.url} target={item.target} rel="noopener noreferrer">
                            {item.title}
                        </a>
                    </li>
                );
            })}
        </Footer.LinkSection>
    ));

    const bottomLinks = footerData?.bottomLinks?.map((link, index) => (
        <Link key={link.url ?? index} href={link.url}>
            {link.title}
        </Link>
    ));

    return (
        <>
            <div className="postenbring-gradient-banner"></div>
            <Footer>
                <Container>
                    <div className="hds-footer__links-and-buttons">
                        <div
                            className="hds-footer__button-link-section"
                            {...(footerData.postenBringDesign
                                ? { "data-color-scheme": "light" }
                                : {})}
                        >
                            {switchLanguageButton}
                            {buttons}
                        </div>
                        <Footer.LinkSections>{mainSections}</Footer.LinkSections>
                    </div>
                    <div className="hds-footer__logo-row">
                        <Footer.Logo asChild>
                            <a
                                href={
                                    "en" == footerData.language
                                        ? "https://www.posten.no/en"
                                        : "https://www.posten.no/"
                                }
                                aria-label="Posten"
                            />
                        </Footer.Logo>
                        {footerData.postenBringDesign && (
                            <Footer.Logo asChild className="hds-theme-bring">
                                <a
                                    href={
                                        "en" == footerData.language
                                            ? "https://www.bring.no/en"
                                            : "https://www.bring.no/"
                                    }
                                    aria-label="Bring"
                                />
                            </Footer.Logo>
                        )}
                    </div>
                    <div className="hds-footer__copyright-and-links">
                        <span className="hds-footer__copyright">{footerData.copyRightText}</span>
                        {bottomLinks}
                    </div>
                </Container>
            </Footer>
        </>
    );
};
